// 按页面划分
export default {
    // 公共页面
    common: {
        detail: '详情',
        confirm: '确定',
        cancel: '取消',
        no_data: '暂无数据',
        no_data_text: '目前没有可展示的数据',
        network_error: '发生错误',
        network_error_text: '我们正在努力解决，请稍后重试。',
        network_contact: '联系我们',
        refresh: '刷新',
    },
    pullCom: {
        pull: '下拉可以刷新',
        release: '释放立即刷新',
        refresh: '正在刷新...',
    },
    index: {
        searchTip: '搜索国家/地区',
        exclusiveTit: '专属优惠',
        more: '更多',
        mainlandTit: '中国内地专区',
        hkPackageTit: '中国香港专区',
        popularDestTit: '热门目的地',
        countryList: {
            cn: '中国内地',
            singapore: '新加坡',
            hk: '中国香港',
            us: '美国',
            thailand: '泰国',
            germany: '德国',
            italy: '意大利',
            more: '更多'
        },
        regionalPackage: '跨区域流量',
        recommendPackage: '为您推荐',
        from: '起',
        guide: '新手指引',
        sepcialArea: '专区',
        lastUpdate: '上次更新',
        successRefresh: '刷新完成',
    },
    packages: {
        sub_title: {
            us: '不含关岛、塞班岛',
            it: '适用梵蒂冈、圣马力诺',
            va: '适用意大利、圣马力诺',
            sm: '适用意大利、梵蒂冈',
            ma: '适用西撒哈拉',
            eh: '适用摩洛哥',
            ch: '适用列支敦士登',
            li: '适用瑞士',
            fr: '适用摩纳哥',
            mc: '适用法国',
            fi: '适用奥兰群岛',
            ax: '适用芬兰',
            gu: '适用塞班岛',
            mp: '适用关岛'
        },
        unlimited_packages: '畅享包',
        normal_packages: '普通包',
        multi_region_packages: '含{area}的跨区域包',
        sale_text: '优惠',
        high_speed_text: '高速流量',
        high_speed_text_year: '高速流量/月',
        periodUnit: {
            day: '天',
            month: '月',
            hour: '小时',
            year: '年',
        },
        periodUnits: {
            day: '天',
            month: '个月',
            hour: '小时',
            year: '年',
        },
        periodUnitSimp: {
            day: '天',
            month: '月',
            hour: '小时',
            year: '年'
        },
        periodUnitsSimp: {
            day: '天',
            month: '个月',
            hour: '小时',
            year: '年'
        },
        unlimited_good_name: {
            day: '包天畅享',
            month: '月畅享',
            year: '年畅享'
        },
        day_invalid: '当天失效',
        month_invalid: '当月失效',
        immediate_valid: '即时生效',
        tomorrow_day_valid: '次日生效',
        tomorrow_month_valid: '次月生效',
    },
    point: {
        title: '我的积分',
        point_history: '积分明细',
        my_point: '我的积分',
        will_expire_on: '积分有效期至',
        total: '总共',
        more: '更多',
        dataPlans:"兑换流量",
        Balance: '兑换余额',
        coupon: '兑换优惠券',
        redeem_for_package: '兑换流量',
        redeem_for_balance: '兑换余额',
        redeem_for_coupon: '兑换优惠券',
        points: '积分',
        signIn:"签到",
        getPoint:"",
        lottery:"生活商城",
        getPrizes:"",
        membership_point_rules: '会员积分使用说明',
        got_it: '知道了',
        tabs: {
            all: '全部',
            earn: '获得',
            redeem: '兑换'
        },
        upgradeApp:"请升级最新版APP",
    },
    member: {
        membership: '会员',
        hello_member: '你好, 会员',
        update: '升级',
        vip_member_benefits: 'VIP会员权益',
        packages: '流量包',
        discounts: '折扣',
        points: '积分',
        membership_policy: '会员协议',
        faq: '常见问题',
        update_to_vip_membership: '升级至VIP会员',
        vip_member: 'VIP会员',
        valid_till: '有效期至',
        renew: '续费',
        months: '个月',
        payment: '支付订单',
        vip_membership: 'VIP会员',
        enjoy_vip_member_benefits: '尊享{len}大VIP会员权益！',
        by_purchasing_you_agree_to: '购买即代表同意',
        coupon: '优惠',
        available_coupon: '{num}个可用',
        no_available_coupon: '暂无优惠',
        actual_price: '实付金额',
        payment_success_text: '购买成功后，相关流量包即可自动到账。',
        balance: '余额',
        online_payment: '在线支付',
        faq_title: '常见问题',
        policy_title: '会员隐私',
        introduce_title: '会员介绍'
    },
    order: {
        periodUnit: {
            day: '天',
            month: '个月',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '个月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '确定支付吗？',
            content: '您将使用余额支付',
            noSelectPackageTitle: '未选择套餐',
            noSelectPackageContent: '请先选择一个套餐',

        },
        purcase_successful: '购买成功',
        vip_membership: 'VIP会员',
        total: '支付金额',
        finish_btn: '返回',
        get_order_status: '正在努力获取订单状态...',
        order_status_tip: '支付待确认',
        order_status_note_user: '支付结果确认中，如10分钟后还未到账，请咨询客服。',
        order_status_btn_text: '完成',
        ios_iap_pay_btn: '立即支付'
    },
    faq: {
        page_title: '常见问题',
        mydevice: '我的设备',
        more: '更多设备',
        more_faq: '更多问题',
        all_device: '全部设备',
        faq_detail: '详情',
    },
    device: {
        page_title: '设备手册',
    },
    vpn: {
        page_title: 'VPN常见问题',
        faq_detail: '详情',
    },
    esim: {
        page_title: "ESIM常见问题",
        faq_detail: 'esim详情'
    },
    deviceGuide: {
        title: '请选择你的设备',
        skip: '跳过',
    },
    give_set: {
        give_set_page_title: '赠送流量设置',
        give_set_page_set_btn: '保存',
        title: '会员赠送套餐设置',
        desc: '升级会员成功后，我们将会定期赠送流量包至您设置的设备上，未绑定设备将不能接收赠送流量包！',
        select_device_placeholder: '请选择设备',
        select_device_title: '选择设备',
        no_device_title: '你还未绑定设备',
        no_device_desc: '请选择绑定设备类型',
        bind_type_by_scan: '扫一扫',
        bind_type_by_type: '按类型',
        disable_device_desc: '赠送流量包无法在您绑定的设备上使用，请绑定对应的设备',
        bind_device: '绑定设备',
        give_set_success: '设置成功',
        give_set_leave_desc: '当前设置未保存，确定离开当前页面吗？',
        give_guide_tip: '点击这里可编辑赠送流量设置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    },
    guide: {
        newUser: {
            title: '新手指引',
            top_bar: {
                device: '我要使用设备网络',
                sim: '我要使用SIM卡网络'
            },
            step: {
                title: '如何使用设备上网',
                bind_device: '绑定设备',
                buy_package: '购买流量',
                use: '开机使用'
            },
            sub_bar: {
                device: '设备',
                package: '流量',
                use: '使用'
            },
            content: {
                device: {
                    list: [
                        {
                            title: '如何绑定设备？',
                            content: [
                                {
                                    text: '1、用户可在首次登录/注册时绑定设备，或者前往【设备】绑定，或者在购买流量包时进行绑定。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2、绑定方法可以通过【扫码绑定】，直接扫一扫设备背面的二维码，有屏设备在【屏幕首页】-【更多设置】中查看。或通过【按型号绑定】，选择具体设备型号，依据指引进行绑定。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                }
                            ],
                        }
                    ]
                },
                package: {
                    list: [
                        {
                            title: '如何购买国内流量包？',
                            content: [
                                {
                                    text: '1、前往【商城】-【本地服务】，浏览商品信息。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2、点击【购买】，然后完成支付。如当前还未绑定设备，请先绑定设备后再购买流量。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                }
                            ]
                        },
                        {
                            title: '如何购买境外流量包？',
                            content: [
                                {
                                    text: '1、前往【首页】，点击【搜索目的地和流量】，输入准备前往的目的地。您可以根据需要灵活选择流量，单一国家、区域或全球流量，包天、7天或30天，5G或4G。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2、点击【购买】，然后完成支付。如当前还未绑定设备，请先绑定设备后再购买流量。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                }
                            ]
                        },
                    ]
                },
                use: {
                    list: [
                        {
                            title: '如何开始上网？',
                            content: [
                                {
                                    text: '1、购买国内（本地服务）流量包后，开启设备将自动激活流量包，已开启的设备需重新启动。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2、购买境外（全球服务）流量包后，在目的地开启设备将自动激活流量包，设备成功连网后即可自由上网。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '（设备第一次连网时间大概需要2-3分钟，请耐心等待）',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                }
                            ]
                        }
                    ],
                },
                sim: {
                list: [
                    {
                        title: '如何使用SIM卡上网？',
                        content: [
                            {
                                text: '1、按照说明书指引，将可用SIM卡插入设备卡槽后再重启设备，即可正常使用（有屏设备需在设备屏幕上切换至SIM卡模式）。',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            },
                            {
                                text: '2、您还可以用手机连接设备的Wi-Fi，在App设备详情页，点击SIM功能切换至SIM模式。',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            }
                        ]
                    }
                ]
                }
            }
    }
    },
    esimRedmption:{
        hd_title1:'eSIM',
        hd_title2:'兑换',
        weclome_text:'请输入您的邮箱和兑换码以获取eSIM流量包，我们会把二维码发送到您的邮箱。收到eSIM二维码后，请在二维码失效时间前将其加载到您的手机上。',
        email:'您的邮箱',
        email_placeholder:'我们将把二维码发送到您的邮箱',
        confirm_mail:'确认邮箱',
        confirm_mail_placeholder:'再次输入邮箱以确保正确无误',
        redemption_code:'兑换码',
        redemption_code_placeholder:'请输入兑换码',
        captcha_code:'验证码',
        captcha_code_placeholder:'请输入验证码兑换',
        redeem:'兑换',
        redeem_success:'兑换成功',
        redeem_success_title:'兑换成功',
        failed:'兑换失败',
        not_received:'未收到邮件？',
        resend_email:'请重新发送邮件',
        empty_email:'请先输入邮箱和确认邮箱',
        email_first:'请先输入邮箱',
        email_confirm_first:'请先输入确认邮箱',
        redemption_code_first:'请先输入兑换码',
        captcha_code_first:'请先输入验证码',
        resend_Success:'邮件将在2小时内发送',
        system_busy:'系统繁忙，请稍后重试',
        resend_failed:'重发失败',
        redeem_failed:'兑换失败',
        resend_success_title:'重发成功'
    }
}




// WEBPACK FOOTER //
// ./src/lang/zh-cn.js